import {getAnonymousHeaders, getURL} from '../utils';
import resolver, {ResolverSettings} from './utils/resolver';
import {OldShortLink, ShortLink} from '../utils/types';

class AuthApi {
  static ENDPOINTS = {
    refresh: () => `checkin-online-token/refresh/`,
    getToken: () => `oauth/apikey-auth`,
    shortLink: (token: string) => `short-link/${token}`,
  };

  async getAuthToken(payload: {apikey: string}, resolverSettings?: ResolverSettings) {
    const response = await resolver(
      '',
      {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: getAnonymousHeaders(),
      },
      {customURL: getURL(AuthApi.ENDPOINTS.getToken(), 'v4'), ...resolverSettings},
    );
    return response.body;
  }

  getChekinToken({token}: {token: string}, resolverSettings?: ResolverSettings) {
    return resolver<OldShortLink | ShortLink>(
      AuthApi.ENDPOINTS.shortLink(token),
      {},
      {
        version: 0,
        requestWithoutToken: true,
        ...resolverSettings,
      },
    );
  }
}

export {AuthApi};
